import React from 'react'
import styled from 'styled-components'

import { icons } from './Button'

const VolumeIcon = styled.div`
  height: 20px
  width: 20px;

  svg {
    height: 100%;
    width: 100%;
  }
`

const Slider = styled.div`
  height: .25rem;
  margin: 0 1.5rem;
  position: relative;
  width: 16rem;
  
  .track,
  .fill {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  
  .track {
    background-color: #ddd;
    border-radius: 4px;
    overflow: hidden;
  }

  .fill {
    background-color: #0019F8;
    transform: ${({ currentVolume }) => `translateX(${currentVolume * 6.25 - 100}%)`};
  }

  .thumb {
    position: absolute;
    left: 0;
    right: 0;

    &:after {
      content: '';
      display: block;
      top: 50%;
      left: 0;
      margin-top: -.8rem;
      height: 1.6rem;
      width: 1.6rem;
      border-radius: .8rem;
      background: white;
      border: 1px solid #ddd;
      box-shadow: 0 2px 3px 0px rgba(0,0,0,.15);
    }
    transform: ${({ currentVolume }) => `translateX(calc(${currentVolume * 6.25}% - ${currentVolume * 1.6}rem / 16))`}
  }
`

const Range = styled.input`
  position: absolute;
  top: 0;
`

export default (props) => {
  return (
    <div style={{ display: 'flex', margin: '1rem', alignItems: 'center' }}>
      <VolumeIcon>{icons.volume}</VolumeIcon>
      <Slider currentVolume={props.currentVolume ? props.currentVolume : 0} isActive={props.isActive}>
        <div className="track">
          <div className="fill"></div>
        </div>
        <div className="thumb"></div>
        <Range
          onChange={props.onChange}
          onMouseUp={props.handleTouchEnd}
          type="range"
          min="0"
          max="16"
          defaultValue={props.defaultValue ? props.defaultValue : 0}
        />
      </Slider>
      <span style={{ width: '1rem' }}>{props.currentVolume ? props.currentVolume : '0'}</span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/VolumeControl.js